import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "~/components/ui/badge";
import { BooksTableDetailRowSectionLabel } from "./books-table-detail-row-section-label";

const MAX_VISIBLE_KEYWORDS = 5;

export const BooksTableDetailRowKeywordBadges = ({
  keywords,
}: {
  keywords: string[];
}) => {
  const { t } = useTranslation(["components"]);
  const [showAll, setShowAll] = useState(false);

  if (keywords.length === 0) return null;

  const visible = showAll ? keywords : keywords.slice(0, MAX_VISIBLE_KEYWORDS);
  const hiddenCount = keywords.length - MAX_VISIBLE_KEYWORDS;

  return (
    <div className="flex max-w-3xl flex-col gap-1.5">
      <BooksTableDetailRowSectionLabel
        label={t("components:booksTable.detail.keywords")}
        count={keywords.length}
      />
      <div className="flex items-center gap-1.5 flex-wrap">
        {visible.map((kw) => (
          <Badge
            key={kw}
            variant="outline"
            className="border-secondary-200 bg-white px-2 py-0.5 min-w-0 text-secondary-600"
          >
            {kw}
          </Badge>
        ))}
        {!showAll && hiddenCount > 0 && (
          <button
            type="button"
            onClick={() => setShowAll(true)}
            className="text-xs text-secondary-400 hover:text-secondary-600 transition-colors"
          >
            {t("components:booksTable.detail.showMore", { count: hiddenCount })}
          </button>
        )}
      </div>
    </div>
  );
};
